export enum EmailProviderType {
	AWS_SES = 'aws-ses',
	SENDGRID = 'sendgrid',
	MAILGUN = 'mailgun',
	SMTP = 'smtp',
	O365 = 'o365',
	GMAIL = 'gmail',
}
